/*
  inserted <script src="//www.vitaravinne.fi/cdn/shop/t/9/assets/ccustomJs.js?v=27490639098503150781791873265" defer="defer"></script>
  just </head> in theme.liquid
*/







import { headerMenuHover } from "./ccustomHeaderMenuHoverJs.js?v=14364868429332831011789978753";
import { addItem } from "./ccustomAddItemJs.js?v=135627610678031570361789978745";
import { cartProgressBar } from "./ccustomCartProgressBarJs.js?v=144318528916891956911789978746";
import { updateCart } from "./ccustomUpdateCartJs.js?v=183353268845345840911789978757";
import { updateCartPage } from "./ccustomUpdateCartPageJs.js?v=79428892339127727961789978758";


(function () {
  
  window.customShopify = {};
  customShopify.convertToPriceStr = (num) => {
    return (num/100).toFixed(2).toString().replace('.',',');
  }
  
  //customShopify.addItem = () => document.querySelector("#CartDrawer-Checkout").addEventListener('mousedown', addItem, {once: true});
  customShopify.cartProgressBar = cartProgressBar;
  customShopify.updateCartPage = updateCartPage;
  customShopify.updateCart = updateCart;
  customShopify.addItem = addItem;
  
  headerMenuHover();
  
  //document.querySelector("#CartDrawer-Checkout").addEventListener('submit', addItem, {bubbles: true});
  
})();